import './styles.css';

import {Component} from 'react'

import {Posts} from '../../components/Posts/index'

import {loadPosts} from '../../utils/load-posts'

import { Button } from '../../components/Button';

import { TextInput } from '../../components/TextInput';
export class Home extends Component { 
  state = {
    posts: [],
    allPosts: [],
    page:0,
    postsPerPage:10,
    searchValue:"",
  };
  async componentDidMount(){ 
    await this.loadPosts();
    };

  loadPosts = async () => { 
    const {page, postsPerPage} = this.state
    const postsAndPhotos = await loadPosts();
    this.setState({
      posts:postsAndPhotos.slice(page,postsPerPage),
      allPosts:postsAndPhotos,
    })};
  loadMorePosts = () => { 
    const { 
      page,
      postsPerPage,
      allPosts,
      posts,
    } = this.state;
    const nextPage = page + postsPerPage;
    const nextPosts = allPosts.slice(nextPage,nextPage + postsPerPage)
    posts.push(...nextPosts)
    this.setState({posts,page:nextPage});
    console.log(page,postsPerPage, nextPage,nextPage + postsPerPage)
  }

  handleChange = (e) =>{ 
    const {value} = e.target;
    this.setState({searchValue: value})

  }

  render () { 
    const {posts,page,postsPerPage, allPosts, searchValue} = this.state 
    const noMorePosts = page + postsPerPage >= allPosts.length;
    const filteredPosts = !!searchValue ?
     allPosts.filter(post =>{ 
      return post.title.toLowerCase() //se searchValue tem valor, filtre os posts retornando todos os posts que contem (includes) o searchValue que eu digitei. Se nao tiver nenhum valor retorne os posts normais como estava antes
      .includes(searchValue.toLowerCase())
     })
     :
     posts; //se existir alguma coisa no searchValue faca posts, se nao fazer outra coisa

  return ( // {!!searchValue} corverte o valor searchValue para booleano, no caso !!searchValue (se tiver busca)
    <section className="container"> 
    <div className='search-container'> 
    {!!searchValue && ( 
      <h1>Search value: {searchValue}  </h1>
    )} 
    <TextInput searchValue = {searchValue} handleChange = {this.handleChange} />
    </div>
      {filteredPosts.length > 0 && ( 
      <Posts posts =  {filteredPosts} />
      )}

      {filteredPosts.length === 0 && ( 
        <p>Não existem posts =( </p> 
      )}

      <div className="button-container">
        {!searchValue &&( 
        <Button 
        text= "Load more posts" 
        onClick = {this.loadMorePosts}
        disabled = {noMorePosts}
      />
        )}

      </div>
      </section>
  );
}
}
